import React from 'react';
import { ProductStatus } from '../types/order/productStatus';

export interface ProductStatusContextProps {
  productStatuses: Map<string, ProductStatus>;
  setProductStatuses: (productStatuses: Map<string, ProductStatus>) => void;
  productStatusesLoading: boolean;
}

const defaultContext: ProductStatusContextProps = {
  productStatuses: new Map(),
  setProductStatuses: () => {},
  productStatusesLoading: false,
};

export const ProductStatusContext = React.createContext<ProductStatusContextProps>(defaultContext);
